import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

const DISMISS_KEY = "fl_install_dismissed";

const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const InstallBanner = () => {
  const [promptEvent, setPromptEvent] = useState(null);
  const [visible, setVisible] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(DISMISS_KEY)) return;
    const onPrompt = (e) => { e.preventDefault(); setPromptEvent(e); setVisible(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIOS()) { setIos(true); setVisible(true); }
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, "1"); setVisible(false); };

  const install = async () => {
    if (!promptEvent) return;
    promptEvent.prompt();
    const { outcome } = await promptEvent.userChoice;
    if (outcome === "accepted") setVisible(false);
    setPromptEvent(null);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-50 bg-forest text-white rounded-2xl shadow-2xl p-4 flex items-start gap-3 animate-in slide-in-from-bottom-4" data-testid="install-banner">
      <img src="/logo-icon.png" alt="Flowerlive" className="w-12 h-12 rounded-xl bg-white p-1 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="font-serif text-base leading-tight">Installa Flowerlive</p>
        {ios ? (
          <p className="text-xs text-white/75 mt-1 flex items-center gap-1 flex-wrap">
            Tocca <Share className="h-3.5 w-3.5 inline" /> e poi <strong>"Aggiungi a Home"</strong>
          </p>
        ) : (
          <p className="text-xs text-white/75 mt-1">Ordina fiori in un tocco, come un'app.</p>
        )}
        {!ios && (
          <button onClick={install} className="mt-3 inline-flex items-center gap-1.5 bg-brand hover:bg-brand-dark text-white text-xs font-semibold px-4 py-2 rounded-full transition-colors" data-testid="install-app-btn">
            <Download className="h-3.5 w-3.5" /> Installa
          </button>
        )}
      </div>
      <button onClick={dismiss} className="text-white/60 hover:text-white transition-colors" aria-label="Chiudi" data-testid="install-dismiss-btn">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
